// YouTubeの埋め込み
function onYouTubeIframeAPIReady() {
	ytPlayer = new YT.Player(
		'topYoutube', // 埋め込む場所の指定
		{
			playerVars: {
              listType : 'playlist',
              list : 'PLCE340D360AF45F65',// YouTubeプレイリストのID
              rel: 0,
              loop: 1,
              height: "100%",
              width: "100%",
              controls: 0,
              autoplay: 1,
              showinfo: 0,
              playsinline: 1,
              host: 'https://www.youtube.com',
              origin:'https://lfyt.jp'
			},
			events: {
				'onReady': onPlayerReady
			}
		}
	);
}

function onPlayerReady(event) {

    event.target.playVideo();
    event.target.mute();

}
